import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { MessageSquare } from 'lucide-react';
import MessagingPanel from '../MessagingPanel';

const BuyerMessagesTab = ({ myRegistrations, setActiveTab, t }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MessageSquare className="h-5 w-5" />
          {t('dashboard.messages')}
        </CardTitle>
        <CardDescription>{t('dashboard.chat_with_exhibitors')}</CardDescription>
      </CardHeader>
      <CardContent>
        {myRegistrations.length === 0 ? (
          <div className="text-center py-8">
            <MessageSquare className="h-12 w-12 text-slate-400 mx-auto mb-4" />
            <p className="text-slate-600 mb-4">{t('dashboard.register_to_message')}</p>
            <Button onClick={() => setActiveTab('events')}>{t('dashboard.events')}</Button>
          </div>
        ) : (
          <MessagingPanel userType="buyer" />
        )}
      </CardContent>
    </Card>
  );
};

export default BuyerMessagesTab;
